import { html, css, LitElement, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { Map, View } from 'ol'
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile'
import olStylesText from 'ol/ol.css?inline';
import { Style, Icon, Text, Fill, Stroke } from 'ol/style'
import Point from 'ol/geom/Point'
import { Coordinate } from 'ol/coordinate';
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import { Modify, defaults as defaultInteractions } from 'ol/interaction'
import Feature from 'ol/Feature'
import { fromLonLat, toLonLat } from 'ol/proj'
import Overlay from 'ol/Overlay';
import { getFavouriteArtists } from './artistutils';
import { getWidth, createEmpty, extend } from 'ol/extent';
import { getIconStyles } from './artistmapstyles';
import { favouritesEl } from './favourites';
import FullScreen from 'ol/control/FullScreen'
import { defaults as defaultControls } from 'ol/control/defaults';
import { Route } from './route'


export class RoutePlanner extends LitElement {
    static styles = [
        unsafeCSS(olStylesText),
        css`
*, ::after, ::before {
    box-sizing: border-box;
}
button {
    font-family: 'Lexend',sans-serif;
}
.ol-full-screen button {
  cursor: pointer;
}
:host { display: block; }
.map {
  width: 100%;
  height: 500px;
  background: #eee;
  position: relative; /* Essential anchor layer */
}
@media(min-width: 768px) {
    .map {
        height: 800px;
    }
}
/* Force OpenLayers overlay nodes to render their contents visible */
:host .ol-overlay-container {
  display: block !important;
  visibility: visible !important;
  position: absolute !important;
}
      /* Force the blue route nodes to stack above the black base nodes */
      :host .ol-overlay-container:has(.custom-html-marker) {
        z-index: 10 !important;
      }

      :host .ol-overlay-container:has(.route-number-marker) {
        z-index: 100 !important;
      }

/* Base Marker Styles */
      .custom-html-marker {
        position: absolute;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #000000;
        color: #ffffff;
        font-family: Arial, sans-serif;
        font-weight: 700;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(-50%, -50%);
        top: 0;
        left: 0;
        cursor: pointer;
        user-select: none;
        text-wrap:nowrap;
      }

      /* New Sequential Marker Styles */
      .route-number-marker {
        position: absolute;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #ffffff;
        color: #333333;
        font-family: Arial, sans-serif;
        font-weight: 700;
        font-size: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(-50%, -50%);
        top: 0;
        left: 0;
        cursor: pointer;
        user-select: none;
        box-shadow: 0 1px 3px rgba(0,0,0,0.4);
      }
      .d-flex {
          display: flex;
      }
   .btn-arts, a.btn-arts  {
        cursor: pointer;
        background-color: #fff;
        border: 1px solid grey;
        color: #131e29;
        font-size: 18px;
        font-weight: 300;
        margin: 30px 12px 30px 0;
        padding: 9px 20px;     
        text-decoration: none;
    }
    .btn-arts:not([disabled]):hover, a.btn-arts:hover {
        background-color: #131e29;
        color: #fff;
    }
    /* tooltip */
    #tooltip {
        position: absolute;
        display: none;
        background: rgba(0, 0, 0, 0.6);
        color: #ffffff;
        padding: 6px 10px;
        border-radius: 4px;
        font-size: 13px;
        font-family: sans-serif;
        white-space: nowrap;
        z-index: 1000;
        pointer-events: none; /* Prevents flickering when mouse hits text */
        transform: translate(-50%, -100%); /* Centers horizontally, shifts above pointer */
        box-shadow: 0 2px 5px rgba(0,0,0,0.3);
    }
        `
    ];

    static get properties() {
        return {
            isLoading: { type: Boolean },
            artists: { type: Array },
            icons: { type: Object },
            iconHtml: { type: String },
            route: { type: Object },
            showButtons: { type: Boolean },
        };
    }

    map = null
    markerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="red" d="M256 0C160 0 82 78 82 174c0 101 80 164 123 239 42 75 42 102 51 102s9-27 51-99c43-75 123-138 123-239C430 78 352 0 256 0zm0 240c-37 0-67-30-67-67 0-37 30-67 67-67s67 30 67 67c0 37-30 67-37 67z"/><circle cx="256" cy="174" r="67" fill="rgba(0,0,0,0.01)"/></svg>`;
    markerSVGUrl = 'data:image/svg+xml;base64,' + btoa(this.markerSVG);
    markerStyle = new Style({
        image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: this.markerSVGUrl,
            scale: 0.05
        }),
    });
    marker = new Feature();
    markerLayer = new VectorLayer({
        source: new VectorSource(),
        declutter: false,
        renderOptions: {
            willReadFrequently: true
        }
    });

    infowindow = undefined

    constructor() {
        super();
        this.isLoading = true;
        this.artists = getFavouriteArtists().filter(artist => {
            return artist.coords
        });
        console.log("favartists", getFavouriteArtists())
        this.selectedRoute = [];
        this.route = new Route()
    }


    fitBounds() {
        if (!this.map || !this.artists || this.artists.length === 0) return;

        // Force an animation frame wait cycle to ensure CSS rendering completes
        setTimeout(() => {
            // 1. Force OpenLayers to sample the real DOM container dimensions
            this.map.updateSize();

            const validPoints = [];

            this.artists.forEach(artist => {
                try {
                    if (artist.coords) {
                        const coords = typeof artist.coords === 'string' ? JSON.parse(artist.coords) : artist.coords;
                        if (coords.longitude && coords.latitude) {
                            const markerCoords = this.getMarkerCords(coords);
                            if (markerCoords) validPoints.push(markerCoords);
                        }
                    }
                } catch (e) {
                    console.error("Failed to parse artist coordinates:", artist, e);
                }
            });

            if (validPoints.length === 0) return;

            const xs = validPoints.map(p => p[0]);
            const ys = validPoints.map(p => p[1]);

            const minX = Math.min(...xs);
            const minY = Math.min(...ys);
            const maxX = Math.max(...xs);
            const maxY = Math.max(...ys);

            const manualExtent = [minX, minY, maxX, maxY];

            // 2. Perform the view adjustment with animation safety checks
            const view = this.map.getView();
            view.fit(manualExtent, {
                maxZoom: 16,
                padding: [50, 50, 50, 50],
                duration: 250 // Adds a short animation to ensure visual recalculation succeeds
            });
        }, 300);
    }


    show() {
        this.fitBounds()
    }

    setArtists(artists) {
        this.artists = artists
        this.infowindow.setPosition(undefined)
        this.clearMarkers()
        this.setupMarkers()
        //this.requestUpdate();
    }

    clearMarkers() {
        if (this.map) {
            this.map.getOverlays().clear();
        }
        // Flush out active routing state references entirely
        this.selectedRoute = [];

        const container = this.shadowRoot.querySelector('#marker-container');
        if (container) container.innerHTML = '';
    }

    getMarkerCords(coords) {
        const lon = parseFloat(coords.longitude);
        const lat = parseFloat(coords.latitude);

        if (isNaN(lon) || isNaN(lat)) {
            return [0, 0];
        }
        return fromLonLat([lon, lat]);
    }


    handleMapClick(source, feature) {
        if (feature) {
            const coordinates = feature.getGeometry().getCoordinates();

            // get any artists with the same coordinates (for multiple artists at the same location)
            const matchingFeatures = source.getFeaturesAtCoordinate(coordinates);
            console.log("Matching features at coordinates:", matchingFeatures)

        } else {

        }
    }

    async setupMarkers() {
        const container = this.shadowRoot.querySelector('#marker-container');

        // Clear any existing HTML elements in the container
        container.innerHTML = '';

        if (this.artists) {
            //console.log(this.artists)
            let elements = [];
            this.artists.forEach(artist => {
                if (artist.coords && artist.listingNumber) {
                    const coords = JSON.parse(artist.coords);
                    const existing = elements.length ? elements.filter(p => p.coords.longitude == coords.longitude && p.coords.latitude == coords.latitude) : null;
                    let allNames = artist.name
                    if (existing && existing.length) {
                        existing.forEach(p => {
                            allNames += ", " + p.name
                        })
                        existing.forEach(p => {
                            p.markerElement.dataset.name = allNames
                        })
                    }
                    
                    const markerCoords = this.getMarkerCords(coords);

                    // 1. Create the HTML Element
                    const markerElement = document.createElement('div');
                    markerElement.className = 'custom-html-marker';

                    // 2. Inject your custom HTML structure or logic
                    markerElement.innerHTML = `<span class="badge">${artist.listingNumber}</span>`;

                    // 3. Attach click events directly to the HTML element if needed
                    markerElement.addEventListener('click', () => {
                        //console.log("Base marker clicked for:", artist.id);

                        // Call the sequence addition logic passing coordinates mapped for this artist loop entry
                        this.addRouteMarker(artist.id, markerCoords)
                        this.setRoute()
                    });


                    elements.push({
                        coords: coords,
                        name: artist.name,
                        markerElement: markerElement
                    })

                    // 4. Wrap the element in an OpenLayers Overlay
                    const overlay = new Overlay({
                        position: markerCoords,
                        positioning: 'center-center', // Try 'center-center' or 'bottom-center' depending on your design
                        element: markerElement,
                        stopEvent: true,
                        zIndex: 10
                    });
                    overlay.artistId = artist.id
                    //console.log(artist)

                    // 5. Add the overlay to the map
                    //console.log("adding overlay", artist.id, this.route.route.find(item => item == artist.id))
                    markerElement.dataset.name = allNames
                    markerElement.addEventListener('mouseenter', (e) => {
                        markerElement.classList.add('is-hovered');
                        console.log("hover");
                        // 1. Get the combined artist name string from the dataset
                        const artistName = e.currentTarget.dataset.name;

                        // 2. Find or create a tooltip element inside your shadowRoot
                        let tooltip = this.shadowRoot.querySelector('#tooltip');

                        // 3. Inject text and position it relative to the hovered marker
                        tooltip.textContent = artistName;
                        tooltip.style.display = 'block';

                        const rect = e.currentTarget.getBoundingClientRect();
                        const containerRect = this.shadowRoot.host.getBoundingClientRect();

                        // Position tooltip directly above the marker badge
                        tooltip.style.left = `${rect.left - containerRect.left + (rect.width / 2)}px`;
                        tooltip.style.top = `${rect.top - containerRect.top - 8}px`;
                    });

                    markerElement.addEventListener('mouseleave', (e) => {
                        markerElement.classList.remove('is-hovered');

                        // Hide the tooltip when the mouse leaves
                        const tooltip = this.shadowRoot.querySelector('#tooltip');
                        if (tooltip) {
                            tooltip.style.display = 'none';
                        }
                    });

                    this.map.addOverlay(overlay);

                    // 6. If there is a route marker then add it
                    if (this.route.route.find(item => item == artist.id)) {
                        this.addRouteMarker(artist.id, markerCoords)
                    }
                }
            });
        }
        if (this.artists && this.artists.length) {
            this.fitBounds()
            await this.setRoute()
        }
    }

    // Method to append a new tracking point to the route list
    addRouteMarker(artistId, markerCoords) {
        if (this.selectedRoute.length >= 10) {
            alert("Google Maps Route Planner has a maximum of 10 stops. Email this route to yourself. Then clear the route and plan another route for the remaining artists.")
        } else {

            // Prevent duplicate additions of the exact same artist to the sequential path
            const alreadyExists = this.selectedRoute.some(item => item.id === artistId);
            if (alreadyExists) return;

            // Append a lightweight marker metadata payload skeleton
            this.selectedRoute.push({
                id: artistId,
                coords: markerCoords,
                overlay: null
            });
        }

    }

    removeRouteMarkers() {
        this.selectedRoute.forEach(item => {
            if (item.overlay) {
                this.map.removeOverlay(item.overlay);
            }
        });
    }

    async clearRoute() {
        this.removeRouteMarkers()
        this.selectedRoute = [];
        await this.setRoute()
    }

    clearAll() {
        this.map.getOverlays().clear();
        this.showButtons = false
    }

    // Method to remove a selected point from the array timeline chain
    async removeRouteMarker(artistId) {
        // Filter out the selected item matching the targeting criteria
        await this.setRoute(artistId);
    }

    // Clears and draws the active sequentially ordered layer instances
    async setRoute(artistIdToRemove) {

        this.showButtons = false
        // 1. Remove old sequential overlays safely
        await this.removeRouteMarkers()

        if (artistIdToRemove) {
            this.selectedRoute = this.selectedRoute.filter(item => item.id != artistIdToRemove);
        }

        this.showButtons = this.selectedRoute.length ? true : false

        // 1.1 Save
        await this.route.setRoute(this.selectedRoute.map(item => item.id)) 

        // 2. Rebuild the sequential markers
        this.selectedRoute.forEach((item, index) => {
            const sequenceNumber = index + 1;

            // Create the element node
            const el = document.createElement('div');
            el.className = 'route-number-marker';
            el.textContent = sequenceNumber;

            // CRITICAL: Explicitly define width and height inline so OpenLayers 
            // knows the dimensions instantly on the first frame without guessing.
            el.style.width = '20px';
            el.style.height = '20px';

            // Handle removal clicks safely
            el.addEventListener('click', async (e) => {
                e.stopPropagation();
                await this.removeRouteMarker(item.id);
            });

            // 3. Wrap instantiation to let the browser process the DOM structure first
            requestAnimationFrame(() => {
                const overlay = new Overlay({
                    position: item.coords,
                    positioning: 'center-center',
                    element: el,
                    stopEvent: true,
                    zIndex: 100 // Keeps it stacked above the black layer
                });


                // Save reference and attach to map
                item.overlay = overlay;
                this.map.addOverlay(overlay);
            });
        });
        this.handleRouteaction()
    }

    //     // Handle clear route button
    //     const btnClearRoute = this.list.querySelector(".clearRoute")
    //         btnClearRoute.addEventListener("click", (e) => {
    //     this.map.clearRoute()
    // })

    raiseRouteChanged() {
        if (this.route) {
            const routeEvent = new CustomEvent("routechanged", {
                detail: this.route.route,
                bubbles: true, // Allows the event to float up through the HTML tree
                cancelable: true
            })
            window.dispatchEvent(routeEvent);
        }
    }

    handleRouteaction() {
        if (!this.isLoading) {
            this.raiseRouteChanged()
        }
        const routeAction = document.getElementById("routeaction")
        if (routeAction) {
            routeAction.style.display = "none"
            if (this.route.route.length > 0) {
                routeAction.style.display = "block"
            }
        }
    }

    async firstUpdated() {

        await this.route.fetchRoute()

        //this.handleRouteaction()
        await this.updateComplete;
        const mapContainer = this.shadowRoot.querySelector('.map');

        const btnClearRoute = this.shadowRoot.querySelector('.clearRoute');
        btnClearRoute.addEventListener("click", async (e) => {
            await this.clearRoute()
        })

        this.map = new Map({
            target: mapContainer,
            interactions: defaultInteractions({
                mouseWheelZoom: false
            }),
            controls: defaultControls().extend([
                new FullScreen()
            ]),
            layers: [
                new TileLayer({
                    source: new OSM(),
                }),
            ],
            view: new View({
                center: fromLonLat([175.0032646, -40.91553427]),
                zoom: 12,
            }),
        });
        this.map.addLayer(this.markerLayer)

        await this.setupMarkers();
        this.map.on('singleclick', (evt) => {
            const feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f);
            const source = this.markerLayer.getSource()
            this.handleMapClick(source, feature);
        })

        // When an artist is removed then remove the marker and the route
        document.addEventListener(favouritesEl.removeEventName, async (e) => {
            const artistId = e.detail.artistId
            console.log(`remove:${artistId}`)
            await this.setRoute(artistId)
            const overlaysArray = this.map.getOverlays().getArray();
            for (const overlay of overlaysArray) {
                if (overlay.artistId == artistId) {
                    this.map.removeOverlay(overlay);
                }
            }
        })
        console.log("fetched route", this.route.route)
        this.isLoading = false;

        
    }

    getRouteLinkValue(artist) {
        if (!artist) return ""
        const coords = JSON.parse(artist.coords)
        let result = `${coords.latitude},${coords.longitude}`
        if (artist.addressoverride) {
            result = artist.addressoverride
        }
        return encodeURIComponent(result)
    }

    getRouteLink() {
        if (!this.selectedRoute || this.selectedRoute.length == 0) return ""
        const firstArtist = this.artists.find(a => a.id == this.selectedRoute[0].id)
        const firstRouteLink = this.getRouteLinkValue(firstArtist)
        if (!firstRouteLink) return ""
        let url = "https://www.google.com/maps/dir/?api=1&waypoints="
            + firstRouteLink
        if (this.selectedRoute.length > 2) {
            var wp = "";
            for (var i = 1; i < this.selectedRoute.length - 1; i++) {
                const artist = this.artists.find(a => a.id == this.selectedRoute[i].id)
                wp += "|" + this.getRouteLinkValue(artist)
            }
            url += wp
        }
        if (this.selectedRoute.length > 1) {
            const i = this.selectedRoute.length - 1
            const artist = this.artists.find(a => a.id == this.selectedRoute[i].id)
            url += "&destination=" + this.getRouteLinkValue(artist)
        }
        return  url
    }

    render() {
        return html`${this.isLoading ? html`<div class="spinner">🌀</div>` : ''}
           <div id="tooltip" class="tooltip"></div>
           <div class="map" style="${this.isLoading ? 'display: none;' : 'display: block;'}"></div>
           
           <div id="marker-container" style="display: none;"></div>
           <div class="d-flex">
                <button style="${this.showButtons ? 'display: flex' : 'display: none'};align-items:center;" class="btn-arts clearRoute"><img src="/img/ArtsTrail/trash.svg" alt="Clear"> Clear route</button>
                <a style="${this.showButtons ? 'display: inline' : 'display: none'}" class="btn-arts route-link" href="${this.getRouteLink()}" target="_blank">Open route in Google Maps</a>
            </div>
        `;
    }
}
customElements.define('route-map', RoutePlanner);